var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto container p-4 pb-16"},[_c('div',{staticClass:"max-w-xl mx-auto"},[_c('loading-capsule',{attrs:{"loaded":!!(_vm.lessons && _vm.lessons.length > 0),"spinner-margin-top":"10rem"}},[_c('lessons-grid')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }